@if (this.isPrijavljen()) {
  <div class="topbar-header-toggle">
    <a
      href="#"
      id="header-button"
      (click)="toggleHeader($event)"
      [class.HeaderClosed]="this.ixNgNavigationService.navUp"
    >
      <i class="fa fa-fw fa-chevron-up"></i>
    </a>
  </div>
}
<div class="topbar-top">
  <img
    alt="Grb Republike Slovenije"
    src="assets/app/svg/RS-logo.427c0427.svg"
    class="topbar-grb-levo"
  />

  <a class="topbar-logo flex-center-vertically" [routerLink]="'/'">
    @if (this.vizitkaService?.data?.row?.postavitevBarva) {
      <div
        class="postavitev-oznaka"
        [style.background-color]="this.vizitkaService?.data?.row?.postavitevBarva"
      >
        {{ this.vizitkaService?.data?.row?.postavitevBesedilo }}
      </div>
    }
  </a>

  @if (this.isPrijavljen()) {
    <!-- IXTLAN Upgrade: Dodaj this.appService.onTopbarItemNavigate($event) -->
    <div class="topbar-icons">
      @if (this.vizitkaService?.data?.row?.userName) {
        <div id="uporabnik">{{ this.vizitkaService?.data?.row?.userName }}</div>
      }

      <a #zacetnaStran1 class="CssTopBar" id="zacetnaStranLink1" [routerLink]="'/zacetnaStran'">
        <i class="topbar-icon material-icons animated swing fa fa-fw fa-home fa-lg"></i>
        <span class="topbar-item-name">Začetna stran</span>
      </a>

      @if (!this.isDevMode() || (this.isDevMode() && this.appService.prikaziNotification)) {
        <a
          #notifications1
          id="userTaskList1"
          class="CssTopBar"
          (click)="nabiralnikComponent.toggle($event, notifications1)"
          href="#"
        >
          <i class="topbar-icon material-icons fa fa-fw fa-envelope fa-lg"></i>
          @if (
            (nabiralnikComponent?.unreadNotificationCount || 0) > 0 &&
            nabiralnikComponent?.wsIsOpened === true
          ) {
            <span class="topbar-badge animated rubberBand">
              {{ nabiralnikComponent.unreadNotificationCount }}
            </span>
          }
          @if (
            nabiralnikComponent?.unreadNotificationCount === null ||
            nabiralnikComponent?.wsIsOpened === false
          ) {
            <i
              class="fas fa-exclamation-triangle fa-xs notificationWarningIcon"
              aria-hidden="true"
            ></i>
          }

          <span class="topbar-item-name">Sporočila</span>
        </a>
      }

      <a
        #userIcon
        class="CssTopBar"
        href="#"
        id="user-display"
        (click)="this.ixNgHtmlUtilsService.onTopbarMenuButtonClick($event)"
      >
        <i class="fa fa-fw fa-user"></i>
      </a>
    </div>

    <ul
      id="topbar-menu"
      tabindex="0"
      role="button"
      class="fadeInDown"
      [ngStyle]="{ display: this.ixNgTopbarService.topbarMenuActive ? 'block' : 'none' }"
      (click)="this.onTopbarMenuClick()"
      (keydown.enter)="this.onTopbarMenuClick()"
    >
      <li
        #profile
        [ngClass]="{ 'menuitem-active': this.ixNgTopbarService.activeTopbarItem === profile }"
      >
        <ul>
          <li role="menuitem">
            <a
              class="disabled"
              style="padding-left: 16px; background-color: rgba(239, 229, 225, 0.5)"
            >
              <i class="fa fa-fw fa-cogs"></i>
              <span>Osebne nastavitve</span>
            </a>
          </li>
          <li role="menuitem">
            <a
              (click)="this.logout()"
              (keydown.enter)="logout()"
              style="padding-left: 16px; cursor: pointer"
              role="button"
              tabindex="0"
            >
              <i class="fa fa-fw fa-sign-out"></i>
              <span>Odjava</span>
            </a>
          </li>
        </ul>
      </li>

      <li
        #favorites
        role="option"
        tabindex="0"
        [attr.aria-selected]="this.ixNgTopbarService.activeTopbarItem === favorites"
        [ngClass]="{
          'menuitem-active': this.ixNgTopbarService.activeTopbarItem === favorites,
          CssHideWhenLarge: true,
        }"
        (click)="this.ixNgHtmlUtilsService.onTopbarItemClick($event, favorites)"
        (keydown.enter)="this.ixNgHtmlUtilsService.onTopbarItemClick($event, favorites)"
      >
        <a id="favoritesLink" href="#" (click)="this.toggleFavoriteList($event)">
          <i class="topbar-icon fa fa-fw fa-star" style="color: #7d8286"></i>
          <span class="topbar-item-name">Priljubljene</span>
        </a>
      </li>
    </ul>

    <lib-nabiralnik #nabiralnikComponent></lib-nabiralnik>
  } @else {
    <button type="button" class="evt-prijava-gumb" (click)="this.login()">Prijava</button>
  }
</div>
